<manage-wrapper
  *ngIf="!!entity"
  [canEditMain]="true"
  [entityTitle]="entity.name"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="false"
  [deleteTitle]="'Delete this Resource Template'"
  [type]="'resource'"
  [titlePlaceholder]="'Resource template name...'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Clipboard Resource Details'"
  [canDuplicate]="false"
  [hideLabels]="true"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateTitle($event)"
  (onDelete)="delete()"
>
  <ng-container *ngIf="!selectedTab || selectedTab?.id === 'details'">

    <div class="uploaders-holder">
      <image-uploader style="margin-top: 15px;"
        [id]="entity.id"
        (newUrls)="changeImage($event, 'resource')"
        [immediate]="true" 
        [isLogo]="true"
        [displayType]="imageUploaderDisplayTypes.widePodLogo"
        [thumbUrl]="entity.logoUrl" 
        [photoUrl]="entity.fullLogoUrl"
        [eventId]="data.accountId"
        [saveName]="entity.name"
        [type]="'resource'" 
        [isTemplate]="true"
        [subtype]="'logo'" 
        [placeholder]="'Add logo'" 
        [uploadText]="'UPLOAD LOGO'"
      ></image-uploader>
    </div>

    <h3 style="margin-top: 20px;">About the resource</h3>
    <joi-input class="description" [disabled]="false" [italicPlaceholder]="true" [(model)]="entity.about" [type]="'textarea'" [returnable]="true" [placeholder]="'About resource...'" (joiChange)="saveEntity()"></joi-input>
        
    <manage-social [links]="entity.social" (saveLinks)="saveSocialLinks($event)"></manage-social>

    <resource-contact-list *ngIf="entity" [resource]="entity" [public]="false" [eventId]="data.accountId" [fromTemplate]="true" (updated)="saveEntity()"></resource-contact-list>

  </ng-container>
</manage-wrapper> 